
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.501 6.085c-2.516 1.299-4.108 3.462-4.9 4.782a2.186 2.186 0 000 2.266C3.792 15.115 6.786 19 12.002 19c2.612 0 4.667-.975 6.217-2.198l-3.51-3.51a3 3 0 11-4-4L7.5 6.085zM19.682 15.438a14.405 14.405 0 001.716-2.305 2.187 2.187 0 000-2.266C20.21 8.885 17.215 5 12 5c-.88 0-1.696.11-2.452.304l10.134 10.134z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.293 2.293a1 1 0 011.414 0l18 18a1 1 0 01-1.414 1.414l-18-18a1 1 0 010-1.414z"}})])
          )
        }
      }
    